module.exports = __webpack_public_path__ + "static/media/loading.fec09f8a.gif";